import axios from "axios";
import consoleLog from "../utils/consoleLog";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_PETOBE_USER_PET_API_BASE_URL_DEV}`
      : `${process.env.REACT_APP_PETOBE_USER_PET_API_BASE_URL_PROD}`,
});

export const getUser = async (username: string) => {
  consoleLog("getUser request body", { username });

  return await API.post(
    "/user/getUser",
    { username },
    {
      transformResponse: [
        (res: any) => {
          const parsedRes = JSON.parse(res);
          return parsedRes;
        },
      ],
    },
  )
    .then((res) => {
      consoleLog("getUser response", res);
      return res?.data?.body?.[0];
    })
    .catch((err) => {
      consoleLog("getUser error", err);
      throw new Error(err);
    });
};
